import {useEffect} from 'react';
import * as Sentry from '@sentry/react';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import {buildVersion} from '../utils/buildVersion';
import {
  getSentryDsn,
  getSentryEnv,
  getSentryErrorReplaysSampleRate,
  getSentryErrorSampleRate,
  getSentryProfilingRate,
  getSentryProject,
  getSentryTracingSampleRate,
} from '../utils/runtimeVars';

const sentryDsn = getSentryDsn();
const sentryEnv = getSentryEnv();
const sentryProject = getSentryProject();
const sampleRate = getSentryErrorSampleRate('1.0');
const tracesSampleRate = getSentryTracingSampleRate('0.2');
const sentryEnabled = !!(sentryDsn && sentryEnv && sentryProject && buildVersion);
const profilingRate = getSentryProfilingRate('0.2');
const errorReplaysSampleRate = getSentryErrorReplaysSampleRate('1.0');

if (sentryEnabled) {
  let params = new URLSearchParams(window.location.search);
  let trace = params.get('trace');
  if (trace) {
    console.log('Enabling Sentry tracing via trace search parameter.');
  }
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnv,
    release: `${sentryProject}@${buildVersion}`,
    integrations: [
      Sentry.browserProfilingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.launchDarklyIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
      }),
    ],
    profilesSampleRate: parseFloat(profilingRate),
    tracesSampleRate: trace ? 1.0 : parseFloat(tracesSampleRate),
    sampleRate: parseFloat(sampleRate),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: parseFloat(errorReplaysSampleRate),
  });
} else {
  console.warn('Sentry not enabled');
}

export const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
